/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Large_Zippy_Crow_MendInputs */

const fr_large_zippy_crow_mend = /** @type {(inputs: Large_Zippy_Crow_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à l'accueil`)
};

/**

* @param {Large_Zippy_Crow_MendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const large_zippy_crow_mend = /** @type {((inputs?: Large_Zippy_Crow_MendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Large_Zippy_Crow_MendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_large_zippy_crow_mend(inputs)
});